export default __webpack_public_path__ + "static/media/payment2.b54a38b4.png";